<template>
    <div>
        <h3 class="text-center md:text-left m-0 py-5 md:pt-9 md:pb-6">
            請選擇欲變更或申請的項目
        </h3>

        <div class="mx-auto md:max-w-full md:min-h-[40vh]">
            <!-- loading -->
            <div
                v-if="isGettingData"
                class="pb-3.5 md:pb-2.5 max-w-lg md:max-w-full mx-auto md:mx-0 overflow-hidden"
            >
                <SkeletonSentence class="w-40 mx-auto md:mx-0" />
                <div class="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-x-6 xl:gap-x-[1.875rem]">
                    <div
                        v-for="i in 4"
                        :key="i"
                        class="mb-4 md:mb-5"
                    >
                        <button class=" menuBtn shine overflow-hidden" />
                    </div>
                </div>
                <SkeletonSentence class="w-32 mt-10 mx-auto md:mx-0" />
                <div class="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-x-6 xl:gap-x-[1.875rem]">
                    <div class="mb-4 md:mb-5">
                        <button class=" menuBtn shine overflow-hidden" />
                    </div>
                </div>
            </div>
            <!-- btn-group -->
            <template
                v-for="(btnBox,i) in btnGroup"
                :key="i"
            >
                <div
                    v-if="btnBox.btns.filter(i=>i.show).length>0"
                    class="pb-3.5 md:pb-2.5 max-w-lg md:max-w-full mx-auto md:mx-0"
                >
                    <h4 class="mb-3 md:mb-5 text-center md:text-left">
                        {{ btnBox.title }}
                    </h4>
                    <div class="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-x-6 xl:gap-x-[1.875rem]">
                        <template
                            v-for="btn in btnBox.btns"
                            :key="btn.transactionItemNo"
                        >
                            <div
                                v-if="btn.show"
                                class="mb-4 md:mb-5"
                            >
                                <!-- selectedClass:user選取＆可反選取 / defaultClass:選取＆不可反選取/ normalClass:未選取＆可被選取的按鈕-->
                                <button
                                    class="btn menuBtn"
                                    :disabled="btn.disabled || btn.confirm"
                                    :class="{ 'selectedClass':(btn.userChecked&&!btn.confirm)||btn.select,'defaultClass':btn.forceSelect&&!btn.confirm, 'normalClass':!btn.userChecked}"
                                    @click="btnSelected(btn)"
                                >
                                    <span>{{ btn.transactionItemName }}</span>
                                </button>
                                <div
                                    v-if="btn.memo"
                                    class="mt-1 text-warning text-sm"
                                >
                                    <SvgIcon
                                        icon-name="warning"
                                        class="inline text-warning w-4 h-4"
                                    />
                                    <span v-html="btn.memo" />
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>
        <Bottombar :control-visible="selectedNum > 0 || $route.name === routeName.ADD_SERVICE">
            <template #left>
                <button
                    v-if="selectedNum=== 0 && $route.name === routeName.ADD_SERVICE"
                    class="btn-text arrow-l"
                    @click="$router.push({ name: routeName.CONFIRM_DATA });"
                >
                    返回資料確認頁面
                </button>
                <div
                    v-if="selectedNum > 0"
                    class="text-gray-200"
                >
                    選擇 {{ selectedNum }} 項變更
                </div>
            </template>
            <template #right>
                <button
                    class="btn btn-accent rounded-full"
                    :disabled="selectedNum === 0"
                    @click="postTransaction"
                >
                    下一步
                </button>
            </template>
        </Bottombar>
        <Popup v-model:visiblePopup="visiblePopup">
            <template #title>
                {{ noticesPopup[0].title }}
            </template>
            <template #content>
                {{ noticesPopup[0].content }}
            </template>
            <template #action>
                <div class="flex flex-col w-full mb-2">
                    <Checkbox
                        v-model:checkedValues="noShowB5Popup"
                        :value="true"
                        class="mb-2"
                        text="不要再詢問我"
                    />
                </div>
                <button
                    class="btn btn-accent rounded-full"
                    @click="popupProgram(true)"
                >
                    {{ noticesPopup[0].cancelButton }}
                </button>
                <button
                    class="btn gradient-primary rounded-full"
                    @click="checkAndClose(noticesPopup[0].itemNo)"
                >
                    {{ noticesPopup[0].confirmButton }}
                </button>
            </template>
        </Popup>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Popup from '@/components/dialogs/Popup.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import routeName from '@/router/constant.js';
import Checkbox from '@/components/checkboxs/Checkbox.vue';
import Loading from '@/components/Loading.vue';
import { getTransactionItems, postTransactionItems } from '@/apis/system';
import { makeSort } from '@/utils/array/makeSort';
import serviceRoutes from '@/json/serviceRoutes';
import modalContent from './modalContent';
import SkeletonSentence from '@/components/skeletons/SkeletonSentence.vue';

export default {
    name: 'Service',
    components: {
        Popup,
        Bottombar,
        Checkbox,
        Loading,
        SkeletonSentence
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const codeIQ = 'IQ';
        const visiblePopup = ref(false);
        const noticesPopup = ref([]);
        const itemMsgList = ref([]);
        const serviceOrderList = ref([]);
        const isLoading = ref(false);
        const isGettingData = ref(false);
        const btnJSON = JSON.parse(JSON.stringify(serviceRoutes));
        const menuItems = ref([]);
        const noShowB5Popup = ref(false);

        const selectedNum = computed(() => {
            const selectd = menuItems.value.filter(i => i.userChecked === true && !i.confirm);
            return selectd.length;
        });

        const btnSelected = (btn) => {
            if (!btn.disabled && !btn.confirm && !btn.forceSelect) {
                btn.userChecked = !btn.userChecked;
            }
        };
        // 進入畫面跳燈箱
        const popupProgram = (close) => {
            // 關掉燈箱並刪除[0]
            if (close && noticesPopup.value[0]) {
                if (noticesPopup.value[0].action === 'add' && noShowB5Popup.value) {
                    localStorage.setItem(`${noticesPopup.value[0].itemNo}Popup`, 'Y');
                    noShowB5Popup.value = false;
                }
                noticesPopup.value.splice(0, 1);
                visiblePopup.value = false;
                $vfm.hide('DialogBase');
            }
            // 開啟燈箱
            if (noticesPopup.value[0]) {
                const noticeData = noticesPopup.value[0];
                const { action, itemNo, title, content, confirmButton, cancelButton } = noticeData;
                if (action === 'add') {
                    visiblePopup.value = localStorage.getItem(`${noticeData.itemNo}Popup`) !== 'Y';
                    if (!visiblePopup.value) {
                        popupProgram(true);
                    }
                } else {
                    modalShow({
                        id: itemNo,
                        title,
                        content,
                        confirmButton,
                        cancelButton,
                    });
                }
            }
        };

        // 離開此頁之前跳燈箱
        const popupBeforeNextPage = (close) => {
            if (close) {
                if (itemMsgList.value[0].action === 'addTransactionItemNo' && itemMsgList.value.length === 1) {
                    postTransaction();
                } else if (itemMsgList.value.length === 1) {
                    nextPage();
                }
                itemMsgList.value.splice(0, 1);
                $vfm.hide('DialogBase');
            }
            if (itemMsgList.value[0]) {
                const id = itemMsgList.value[0].code;
                modalShow(modalContent[id]);
            }
        };
        // 勾選特定變更項目
        const checkTransaction = (itemNo) => {
            menuItems.value.forEach(i => {
                if (i.transactionItemNo === itemNo) {
                    i.userChecked = true;
                }
            });
        };
        // 加選項目 關閉在接續打開
        const checkAndClose = (itemNo) => {
            checkTransaction(itemNo);
            popupProgram(true);
        };

        // 按鈕分類
        const btnGroup = computed(() => {
            const btnBox = [
                {
                    id: 2,
                    title: '投資內容變更',
                    btns: []
                },
                {
                    id: 1,
                    title: '基本資料變更與申請',
                    btns: []
                },
                {
                    id: 3,
                    title: '契約內容變更',
                    btns: []
                }
            ];
            menuItems.value.forEach((btnObj) => {
                btnBox.forEach((obj) => {
                    if (btnObj.transactionItemKind === obj.id) { obj.btns.push(btnObj); }
                });
            });
            return btnBox;
        });

        // 取得資料
        const getData = () => {
            // 來自
            if (route.name === routeName.ADD_SERVICE) {
                menuItems.value = store.state.services.transactionItems;
                // 若選了投資屬性相關的變更項目，需禁止選取投資屬性問卷
                const hasNeedCheckInvest = menuItems.value.find(i => i.needCheckInvest && i.userChecked);
                if (hasNeedCheckInvest) {
                    menuItems.value.forEach(i => {
                        if (i.transactionItemNo === codeIQ && !i.userChecked) {
                            i.disabled = true;
                        }
                    });
                }
            } else {
                isGettingData.value = true;
                getTransactionItems().then((res) => {
                    menuItems.value = res.data.menuItems.map(i => {
                        const mappingBtn = btnJSON.find((j) => j.code === i.transactionItemNo);
                        i.userChecked = i.select || i.forceSelect;
                        i.confirm = false;
                        i.routeName = mappingBtn?.routeName || '';
                        return i;
                    });
                    if (res.data.noticeList.length > 0) {
                        noticesPopup.value = res.data.noticeList;
                    }
                    if (noticesPopup.value.length > 0) {
                        popupProgram();
                    }
                }).finally(() => {
                    isGettingData.value = false;
                });
            }
        };
        getData();

        /** 燈箱 */
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        // 下一步itemMsgList回傳燈箱資料;
                        if (itemMsgList.value.length > 0) {
                            switch (itemMsgList.value[0]?.action) {
                                // 新增變更項目
                                case 'addTransactionItemNo': {
                                    checkTransaction(itemMsgList.value[0].transactionItemNo);
                                    popupBeforeNextPage(true);
                                    break;
                                }
                                // close 關閉燈箱且停止後續運作
                                case 'close': {
                                    $vfm.hide('DialogBase');
                                    if (itemMsgList.value[0]?.code === 'MSG50') {
                                         nextPage();
                                    }
                                    break;
                                }
                                // 連結至其他頁面
                                case 'openUrl': {
                                    const url = itemMsgList.value[0].url;
                                    window.open(url, '_blank');
                                    $vfm.hide('DialogBase');
                                    break;
                                }
                                // next 關閉燈箱且繼續流程
                                case 'next': {
                                    popupBeforeNextPage(true);
                                    break;
                                }
                            };
                        } else {
                            // 進入畫面時與下一步打api之前 判斷
                            switch (params.id) {
                                default: {
                                    popupProgram(true);
                                    break;
                                }
                            };
                        }
                    },
                    cancel() {
                        $vfm.hide('DialogBase');
                        // 進入就跳的燈箱 取消後還是會繼續判斷有沒有下一個
                        if (!itemMsgList.value.length) {
                            popupProgram(true);
                        }
                    },
                },
            });
        };

        /** 變更項目送至後端排序 */
        const postTransaction = async () => {
            isLoading.value = true;
            const list = menuItems.value.filter(i => i.userChecked);
            const serviceItems = list.map(item => item.transactionItemNo);
            postTransactionItems(serviceItems)
                .then((res) => {
                    serviceOrderList.value = res.data.menuItems || [];
                    itemMsgList.value = res.data.itemMsgList;

                    if (res.data?.itemMsgList.length > 0) {
                        isLoading.value = false;
                        popupBeforeNextPage();
                        // 包含A6A7燈箱 刪除A6 vuex資料 移除confirm + 將A6加入當次變更
                        const hasA6A7 = itemMsgList.value.findIndex(i => i.code === 'A6A7');

                        if (hasA6A7 > -1) {
                            const resultStore = store.state.services.changeItemsResult;
                            const keys = Object.keys(resultStore);
                            keys.forEach(i => {
                                if (i.substr(0, 2) === 'A6') {
                                    delete resultStore[i];
                                }
                            });
                            menuItems.value.forEach(i => {
                                if (i.transactionItemNo === 'A6') {
                                    i.confirm = false;
                                    // i.userChecked=true;
                                }
                            });
                        }
                    } else {
                        nextPage();
                    }
                    // 取得後端排好的順序 再放入route & confirm(是否到過確認頁面)
                }).catch(() => {
                    isLoading.value = false;
                });
        };

        // 前往IQ提示燈箱
        const goIQPopup = (nextRoute) => {
            $vfm.show({
                component: 'DialogBase',
                params: modalContent.GOIQ,
                on: {
                    confirm() {
                        // store.dispatch('services/setChangeItemsResult', { code: codeIQ, value: store.state.policy.investType });
                        store.dispatch('services/setFromIQRedirect', nextRoute);
                        window.location = `${process.env.VUE_APP_CONTEXT_PATH}/invq-forward`;
                        $vfm.hide('DialogBase');
                    },
                    cancel() {
                        isLoading.value = false;
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };
        // api 打完之後存資料並下一頁
        const nextPage = () => {
            store.dispatch('services/setTransactionItems', menuItems.value);
            const services = serviceOrderList.value.map(i => {
                const obj = menuItems.value.find(j => i.transactionItemNo === j.transactionItemNo);
                i.routeName = obj.routeName;
                i.confirm = obj.confirm;
                return i;
            });
            const list = makeSort(services, 'transactionItemOrder').filter(i => !i.confirm && i.transactionItemNo !== codeIQ);
            store.dispatch('services/setServices', list);
            // 下一頁要去的頁面名稱
            const nextRoute = route.name === routeName.SERVICE ? routeName.CONFIRM_TEL_MAIL
                : list.length > 0 ? list[0].routeName : routeName.CONFIRM_DATA;
            // 有問卷需填寫或確認，需要轉去問卷平台，再轉回來接下來的頁面
            const indexUndoIQ = services.findIndex(i => !i.confirm && i.transactionItemNo === codeIQ);

            if (indexUndoIQ > -1) {
                goIQPopup(nextRoute);
            } else {
                router.push({ name: nextRoute });
            }
        };
        return {
            visiblePopup,
            btnGroup,
            selectedNum,
            routeName,
            noShowB5Popup,
            noticesPopup,
            btnSelected,
            isGettingData,
            isLoading,
            popupProgram,
            checkAndClose,
            postTransaction
        };
    },
};
</script>
<style scoped lang="scss">
.menuBtn {
    @apply w-full min-h-[3.4375rem] md:justify-start md:text-left md:px-2.5 md:tracking-tight leading-tight text-base xs:text-[1.125rem] rounded-md;
    &.normalClass {
        @apply bg-white text-black border-dashed border-gray-400 md:border-0 lg:hover:ring-1 lg:hover:ring-secondary lg:hover:ring-offset-0;
    }
    &:disabled,
    &.disabledClass {
        @apply border-0 bg-gray-50 md:bg-gray-75 text-gray-200 no-animation cursor-auto;
    }
    &.defaultClass {
        @apply no-animation gradient-primary cursor-auto;
        span {
            @apply opacity-50;
        }
    }
    &.selectedClass {
        @apply border-0 gradient-primary text-white;
    }
}
</style>
